import {
  JavascriptTypes
} from '../../constants';

class CatalogueCategory {

  constructor(fields) {
    this.fields = fields;
  }

  getBanner(imageUrl) {

    if (typeof imageUrl === JavascriptTypes.String) {
      let imageLocation = imageUrl.slice(0, imageUrl.lastIndexOf('.'));
      let imageExtension = imageUrl.slice(imageUrl.lastIndexOf('.'), imageUrl.length);

      return imageLocation.concat(`_banner${imageExtension}`);
    }

    return '';
  }

  mapVendors(vendors) {
    return vendors.map(vendor => {

      if (vendor.attachment?.url) {

        return {
          ...vendor,
          attachment: {
            ...vendor.attachment,
            banner: this.getBanner(vendor.attachment.url),
            logo: vendor.attachment.url
          }
        };
      }

      return vendor;
    });
  }

  mapToStandard() {

    return {
      description: this.fields?.description,
      id: this.fields?.id,
      name: this.fields?.name,
      attachment: this.fields?.attachment,
      vendors: this.mapVendors(this.fields?.subCategory)
    };
  }
}

export class CatalogueCategories {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    const categories = [];

    for (let i = 0; i < this.fields?.length; i ++) {

      categories.push(new CatalogueCategory(this.fields[i]).mapToStandard());
    }

    return categories;
  }
}